import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

const OrderBookSummary = ({ orderInfo, approvalList }) => {
  const [finalApproveDate, setFinalApproveDate] = useState('');

  useEffect(() => {
    if (approvalList && approvalList.length > 0) {
      const length = approvalList.length;
      const docuDt = approvalList[length - 1]['docuDt'];

      setFinalApproveDate(docuDt);
    }
  }, [approvalList]);

  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            문서번호
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            문서명
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            작성일자
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            작성자
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div">
            결재상태
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div">
            최종승인일자
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {orderInfo?.roNo}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            수주품의서
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {orderInfo?.crtDt}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            {orderInfo?.crtNm}
          </Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div">
            {orderInfo?.ordYn === 'S' && '진행중'}
            {orderInfo?.ordYn === 'Y' && '완료'}
            {orderInfo?.ordYn === 'N' && '미결재'}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div">
            {finalApproveDate}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderBookSummary;
